jQuery(function ($) {
    $(document).ready(function(e) {

        var hiddenButtons = $('.news-filters__filter');
        var hidden = "-hidden";
        var notVisible = true;
        var menu = false;

        /**
         * Toggle the display of the search form inputs when button is clicked
         */

        if (hiddenButtons) {

            $('.news-filters').append('<a class="subnav__wrapper-menu-button" href="#">View Success Story Filters</a>');
            menu = true;
            var searchFormToggle = $('.subnav__wrapper-menu-button');

            hiddenButtons.addClass(hidden);

            searchFormToggle.on('click', function (e) {
                e.preventDefault();

                if (notVisible) {
                    notVisible = false;
                    hiddenButtons.slideDown(200, 'linear', function () {
                        $(this).removeClass(hidden);
                        $('.subnav__wrapper-menu-button').text('Hide Success Story Filters');
                    });
                } else if (!notVisible) {
                    notVisible = true;
                    hiddenButtons.slideUp(200, 'linear', function () {
                        $(this).addClass(hidden);
                        $('.subnav__wrapper-menu-button').text('View Success Story Filters');
                    });
                }
            });
        }
    });
});